import clsx from "clsx";

const Badge = ({ variant = "default", children, className, ...props }) => {
  const variants = {
    default: "bg-gray-50 text-gray-500",
    white: "bg-white text-[#0B1120] border border-gray-100",
    yellow: "bg-yellow-50 text-yellow-700",
    red: "bg-red-50 text-red-700",
    green: "bg-green-50 text-green-700",
    cyan: "bg-cyan-50 text-cyan-700",
    blue: "bg-blue-50 text-blue-600",
    violet: "bg-violet-50 text-violet-700",
  };

  return (
    <span
      className={clsx(
        "px-2.5 py-1 text-xs font-bold uppercase tracking-wide rounded-full whitespace-nowrap",
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
